import { c as _c } from "react/compiler-runtime";
import { FlexCenter } from "@opensea/ui-kit";
import { OpenSeaBrandLogo, OpenSeaLetters } from "@opensea/ui-kit/icons";
export function IntroStepLogo() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FlexCenter className="items-end gap-4.5"><OpenSeaBrandLogo size={54} /><OpenSeaLetters className="translate-y-0.5" height={42.54} /></FlexCenter>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}